import { FlexAlignCenterSpaceBetween } from 'components/primitives/flex';
import styled from 'styled-components';
import Button from 'components/ui/Button/Button';
import { useResetAtom } from 'jotai/utils';
import { useSetAtom } from 'jotai';
import FilterButton, { CustomFilterButtonProps } from '../FilterButton';
import { isAnyFilterActiveAtom, resetAllFiltersAtom } from '../filterStore';
import OtherFiltersContent, { OtherFiltersLabel } from './OtherFiltersContent';
import { atomWithToggle } from '../atomUtils';

export const otherFiltersDropdownVisibleAtom = atomWithToggle(false);

export default function OtherFiltersFilterButton(props: CustomFilterButtonProps) {
  const { toggleFilterDropdown, dropdownActive } = props;
  const resetFilters = useResetAtom(resetAllFiltersAtom);
  const toggleFilterVisible = useSetAtom(otherFiltersDropdownVisibleAtom);

  const handleToggle = (name) => {
    if (dropdownActive) {
      toggleFilterVisible(false);
    } else {
      toggleFilterVisible(true);
    }
    toggleFilterDropdown(name);
  };

  return (
    <FilterButton
      {...props}
      toggleFilterDropdown={handleToggle}
      hideCloseButton
      showCloseCross
      mobileFullscreen
      isFilterActiveAtom={isAnyFilterActiveAtom}
      label={<OtherFiltersLabel />}
      content={<OtherFiltersContent />}
      extraElementOutsideContent={
        <BottomBar>
          <ClearOtherFiltersButton onClick={resetFilters}>Clear all</ClearOtherFiltersButton>
          <Button
            text="See results"
            className="resultsBtn"
            onClick={() => {
              toggleFilterVisible(false);
              toggleFilterDropdown(null);
            }}
          />
        </BottomBar>
      }
    />
  );
}

const BottomBar = styled(FlexAlignCenterSpaceBetween)`
  position: sticky;
  inset: 0 0 0 0;
  top: unset;
  background: #ffffff;
  box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.04);
  padding: 20px 20px 24px;

  .resultsBtn {
    padding: 0 22px;
  }
`;

const ClearOtherFiltersButton = styled.button`
  font-weight: 500;
  font-size: 15px;
  color: #0751c2;
  padding: 18px 22px;
`;
